import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { I18nLookup } from 'pricing-pages-lib/utils/languageUtils';
import { useEffect } from 'react';
import { useAllEligibleAddOnsWithTranslations } from '../../hooks/useAllEligibleAddOnsWithTranslations';
import { useAppSelector } from '../../reducers';
import { billingNameKeySelector } from '../../selectors/ProductsSelectors';
import { AddOnCard } from './AddOnCard';
import { AddOnsSearchProvider, useAddOnsSearch } from './AddOnsSearchContext';
import AddOnsSearchFilter from './AddOnsSearchFilter';
import { HubSpotCreditsCard } from './HubspotCreditsCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AvailableAddOnsListContent = ({
  screen,
  minimumAddOnsForSearch = 5,
  highlightedProduct
}) => {
  const {
    searchTerm,
    setSearchTerm
  } = useAddOnsSearch();

  // get the billing name key for the highlighted product
  const highlightedProductBillingNameKey = useAppSelector(state => highlightedProduct !== null && highlightedProduct !== void 0 && highlightedProduct.skuId ? billingNameKeySelector(state, {
    skuId: highlightedProduct.skuId
  }) : '');

  // if the highlighted product has a billing name key, set the search term to the translated title of the product
  useEffect(() => {
    if (!highlightedProductBillingNameKey) return;
    const i18nKey = `pricing-pages-ui.productNamesV2.${highlightedProductBillingNameKey}.title`;
    if (I18nLookup(i18nKey)) {
      setSearchTerm(I18n.text(i18nKey));
    }
  }, [highlightedProductBillingNameKey, setSearchTerm]);
  const {
    addOns,
    totalAddOns,
    loading: showLoadingSpinner,
    loaded: haveAllApisLoaded
  } = useAllEligibleAddOnsWithTranslations({
    searchTerm
  });
  const showNoResultsMessage = haveAllApisLoaded && addOns.length === 0 || haveAllApisLoaded && searchTerm && addOns.length === 0;
  const showSearch = (totalAddOns > minimumAddOnsForSearch || !!highlightedProduct) && !showLoadingSpinner;
  return /*#__PURE__*/_jsxs(View, {
    children: [showLoadingSpinner && /*#__PURE__*/_jsx(LoadingSpinner, {
      minHeight: 200,
      size: "md",
      grow: true
    }), showSearch && /*#__PURE__*/_jsx(AddOnsSearchFilter, {}), showNoResultsMessage && /*#__PURE__*/_jsxs(View, {
      marginBlockStart: "400",
      textAlign: "center",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.addOns.search.noResults"
        })
      }), /*#__PURE__*/_jsx(Illustration, {
        name: "empty-state-charts",
        height: "282px",
        margin: "auto"
      })]
    }), !showLoadingSpinner && addOns.map(({
      skuId,
      isHubSpotCredits
    }) => {
      if (isHubSpotCredits) {
        return /*#__PURE__*/_jsx(HubSpotCreditsCard, {
          skuId: skuId,
          screen: screen
        }, skuId);
      }
      return /*#__PURE__*/_jsx(AddOnCard, {
        skuId: skuId,
        screen: screen
      }, skuId);
    })]
  });
};
const AvailableAddOnsList = props => {
  return /*#__PURE__*/_jsx(AddOnsSearchProvider, {
    children: /*#__PURE__*/_jsx(AvailableAddOnsListContent, Object.assign({}, props))
  });
};
export default AvailableAddOnsList;